import React from 'react';
import { motion } from 'framer-motion';

import useAnimate from './Motion';

/**
 * The house reveal: content rises, sharpens, and settles once as it enters view.
 * `delay` staggers siblings; `y` tunes the travel distance.
 */
export default function Reveal({
    children,
    as = 'div',
    delay = 0,
    y = 34,
    duration = 0.9,
    amount = 0.35,
    className,
    ...rest
}) {
    const animate = useAnimate();
    const Tag = motion[as] || motion.div;

    if (!animate)
        return React.createElement(as, { className, ...rest }, children);

    return (
        <Tag
            className={className}
            initial={{ opacity: 0, y, filter: 'blur(10px)' }}
            whileInView={{ opacity: 1, y: 0, filter: 'blur(0px)' }}
            viewport={{ once: true, amount }}
            transition={{ duration, delay, ease: [0.16, 1, 0.3, 1] }}
            {...rest}
        >
            {children}
        </Tag>
    );
}
